module.exports = __webpack_public_path__ + "static/deposit-money-8c6ade6e3b818a4f1d86ed3be26696ef.svg";